import React, { useEffect, useState } from 'react';
import { API_COPY_CREDITS } from '../../common/EsConstants';
import { esRead } from '../../common/EsFetch';
import { useEsTranslationsFlag } from '../../common/EsFlags';
import { esFormatSeries } from '../../common/EsIntl';
import { useEsStrings } from '../../common/EsStrings';

/**
 * Legal & Credits' Translations: the translators who chose a credit name, by locale group.
 * Behind rolloutEsTranslations with the copy/ API it reads, and nothing at all while it loads, when
 * nobody is credited, or when esback does not answer: the rest of a legal notice must not wait
 * on a credit list.
 */
export default function EsTranslationCredits() {
    const t = useEsStrings();
    const on = useEsTranslationsFlag();
    const [ credits, setCredits ] = useState( [] );

    useEffect( () => {
        if ( !on ) return undefined;
        let aLive = true;
        esRead( API_COPY_CREDITS )
            .then( ( pCredits ) => { if ( aLive && Array.isArray( pCredits ) ) setCredits( pCredits ); } )
            .catch( () => {} );
        return () => { aLive = false; };
    }, [ on ] );

    if ( !on || credits.length === 0 ) return null;

    return (
        <>
            <h4 data-testid="es-legal-translations-heading" className="mb-3 text-lg font-bold text-heading">
                { t( 'translate-credits-heading', 'Translations' ) }
            </h4>
            <p data-testid="es-legal-translations-notice" className="mb-3 text-base leading-8">
                { t( 'translate-credits-notice', 'Escapade is translated by the people who play on it. Thank you.' ) }
            </p>
            <ul data-testid="es-legal-translations" className="mb-6 text-base leading-8">
                { credits.map( ( pGroup ) => (
                    <li key={ pGroup.group } data-testid={ 'es-legal-translations-' + pGroup.group }>
                        <span className="font-semibold" lang={ pGroup.group }>{ pGroup.nativeName }</span>
                        { ' — ' }
                        { esFormatSeries( pGroup.names ) }
                    </li>
                ) ) }
            </ul>
        </>
    );
}
